/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Component encoding (the default) escapes reserved characters like & = ? /, so it's right for a single query value. Full-URI encoding leaves those characters in place, so it's right for an entire URL.`)
};

const es_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La codificación de componentes (predeterminada) escapa caracteres reservados como & = ? /, por lo que es correcta para un valor de consulta único. La codificación de URI completa deja esos caracteres en su lugar, por lo que es correcta para una URL completa.`)
};

const de_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komponenten-Kodierung (die Standardeinstellung) escapt reservierte Zeichen wie & = ? /, richtig für einen einzelnen Query-Wert. Vollständige URI-Kodierung lässt diese Zeichen an Ort und Stelle, richtig für eine ganze URL.`)
};

const nl_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderdeel-codering (de standaard) slaat gereserveerde karakters om zoals & = ? /, dus het is geschikt voor één querywaarde. Volledige-URI-codering laat die karakters op hun plaats, dus het is geschikt voor een volledige URL.`)
};

const fr_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'encodage des composants (le défaut) échappe aux caractères réservés comme & = ? /, donc c'est correct pour une seule valeur de requête. L'encodage URI complet laisse ces caractères en place, donc c'est correct pour une URL entière.`)
};

const it_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La codifica del componente (impostazione predefinita) esegue l'escape dei caratteri riservati come & = ? /, quindi è giusta per un singolo valore di query. La codifica full-URI lascia questi caratteri al loro posto, quindi è giusta per un intero URL.`)
};

const pt_br2_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A codificação de componente (padrão) escapa caracteres reservados como & = ? /, portanto é correta para um valor de consulta único. A codificação Full-URI deixa esses caracteres em seu lugar, portanto é correta para uma URL inteira.`)
};

const pt_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificação de componente (o padrão) escapa caracteres reservados como & = ? /, por isso é apropriada para um valor de consulta único. Codificação de URI completo deixa esses caracteres no lugar, por isso é apropriada para um URL inteiro.`)
};

const ja_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンポーネント エンコーディング (デフォルト) は & = ? / のような予約文字をエスケープするため、単一のクエリ値に最適です。Full-URI エンコーディングはそれらの文字をそのままにしておくため、完全なURLに最適です。`)
};

const zh_ue_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组件编码（默认方式）会转义 & = ? / 等保留字符，因此适合单个查询值。完整 URI 编码会保留这些字符，因此适合整个 URL。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_faq1_a", locale)
	if (locale === "en") return en_ue_faq1_a(inputs)
	if (locale === "es") return es_ue_faq1_a(inputs)
	if (locale === "de") return de_ue_faq1_a(inputs)
	if (locale === "nl") return nl_ue_faq1_a(inputs)
	if (locale === "fr") return fr_ue_faq1_a(inputs)
	if (locale === "it") return it_ue_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ue_faq1_a(inputs)
	if (locale === "pt") return pt_ue_faq1_a(inputs)
	if (locale === "ja") return ja_ue_faq1_a(inputs)
	return zh_ue_faq1_a(inputs)
};